import clsx from 'clsx';

interface FlyerPortraitDoubleSidedProps {
  className?: string;
}

const FlyerPortraitDoubleSided: React.FC<FlyerPortraitDoubleSidedProps> = ({ className }) => {
  return (
    <svg
      className={clsx('flyer-portrait-double-sided', className)}
      fill="none"
      height="148"
      viewBox="0 0 120 148"
      width="120"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0.5H112C116.142 0.5 119.5 3.85786 119.5 8V136C119.5 140.142 116.142 143.5 112 143.5H12C7.85787 143.5 4.5 140.142 4.5 136V8C4.5 3.85787 7.85787 0.5 12 0.5Z"
        fill="white"
      />
      <path
        d="M12 0.5H112C116.142 0.5 119.5 3.85786 119.5 8V136C119.5 140.142 116.142 143.5 112 143.5H12C7.85787 143.5 4.5 140.142 4.5 136V8C4.5 3.85787 7.85787 0.5 12 0.5Z"
        stroke="#D1D2D4"
      />
      <path
        d="M8 4.5H108C112.142 4.5 115.5 7.85786 115.5 12V140C115.5 144.142 112.142 147.5 108 147.5H8C3.85787 147.5 0.5 144.142 0.5 140V12C0.500002 7.85787 3.85787 4.5 8 4.5Z"
        fill="white"
      />
      <path
        d="M8 4.5H108C112.142 4.5 115.5 7.85786 115.5 12V140C115.5 144.142 112.142 147.5 108 147.5H8C3.85787 147.5 0.5 144.142 0.5 140V12C0.500002 7.85787 3.85787 4.5 8 4.5Z"
        stroke="#D1D2D4"
      />
      <rect fill="#D1E7DD" height="128" width="100" x="8" y="12" />
      <path
        d="M65.5 64H55C53.3431 64 52 65.3431 52 67C50.3431 67 49 68.3431 49 70V85C49 86.6569 50.3431 88 52 88H62.5C64.1569 88 65.5 86.6569 65.5 85C67.1569 85 68.5 83.6569 68.5 82V67C68.5 65.3431 67.1569 64 65.5 64ZM65.5 83.5V70C65.5 68.3431 64.1569 67 62.5 67H53.5C53.5 66.1716 54.1716 65.5 55 65.5H65.5C66.3284 65.5 67 66.1716 67 67V82C67 82.8284 66.3284 83.5 65.5 83.5ZM50.5 70C50.5 69.1716 51.1716 68.5 52 68.5H62.5C63.3284 68.5 64 69.1716 64 70V85C64 85.8284 63.3284 86.5 62.5 86.5H52C51.1716 86.5 50.5 85.8284 50.5 85V70Z"
        fill="#75B798"
      />
    </svg>
  );
};


export default FlyerPortraitDoubleSided;
